/**
 * @generated SignedSource<<d05ce61a55709c04fa09df03dce40195>>
 * @relayHash ba73a1b1a25531c51148680931790351
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7949d30d5cbda8567db14c4dd6f906d5174d5e8c93c835b3cc8965648a4f2eb8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreeQuery$variables = {
  contentId: string;
  isReplacePagesWithPTPageEnabled: boolean;
  isSuperAdmin: boolean;
  paginationLimit?: number | null | undefined;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null | undefined> | null | undefined;
  spaceKey: string;
  statuses?: ReadonlyArray<GraphQLPageStatus | null | undefined> | null | undefined;
};
export type PageTreeQuery$data = {
  readonly currentPage: {
    readonly blank: boolean | null | undefined;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly createdDate: {
      readonly value: string;
    } | null | undefined;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null | undefined;
            readonly createdDate: {
              readonly value: string;
            } | null | undefined;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
                readonly version: {
                  readonly number: number | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly status: PTGraphQLPageStatus | null | undefined;
            readonly subType: string | null | undefined;
            readonly title: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null | undefined;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null | undefined;
            readonly createdDate: {
              readonly value: string;
            } | null | undefined;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
                readonly version: {
                  readonly number: number | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly status: PTGraphQLPageStatus | null | undefined;
            readonly subType: string | null | undefined;
            readonly title: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly status: PTGraphQLPageStatus | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly ptpage?: {
    readonly blank: boolean | null | undefined;
    readonly createdDate: {
      readonly value: string;
    } | null | undefined;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly status: PTGraphQLPageStatus | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly rootLevelPages?: {
    readonly nodes: ReadonlyArray<{
      readonly blank: boolean | null | undefined;
      readonly hasChildren: boolean | null | undefined;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly id: string | null | undefined;
      readonly links: {
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly status: GraphQLPageStatus | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly homepage: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type PageTreeQuery = {
  response: PageTreeQuery$data;
  variables: PageTreeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isReplacePagesWithPTPageEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statuses"
},
v7 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v8 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v9 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v10 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "title"
},
v13 = {
  "kind": "ScalarField",
  "name": "status"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v16 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v17 = {
  "kind": "ScalarField",
  "name": "blank"
},
v18 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "type"
},
v20 = {
  "kind": "ScalarField",
  "name": "subType"
},
v21 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v22 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v14/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v23 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v24 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ]
  },
  {
    "concreteType": "PTPageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v23/*: any*/)
    ]
  }
],
v25 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v24/*: any*/)
},
v26 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v24/*: any*/)
},
v27 = [
  {
    "alias": "currentPage",
    "args": [
      (v7/*: any*/),
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      },
      (v25/*: any*/),
      (v26/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": (v24/*: any*/)
      }
    ]
  },
  {
    "condition": "isReplacePagesWithPTPageEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v26/*: any*/)
        ]
      }
    ]
  },
  {
    "condition": "isReplacePagesWithPTPageEnabled",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "rootLevelPages",
        "args": [
          (v9/*: any*/),
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "statuses"
          }
        ],
        "concreteType": "PaginatedPageList",
        "kind": "LinkedField",
        "name": "pages",
        "plural": false,
        "selections": [
          {
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v11/*: any*/)
        ]
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeQuery",
    "selections": (v27/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeQuery",
    "selections": (v27/*: any*/)
  },
  "params": {
    "cacheID": "ba73a1b1a25531c51148680931790351",
    "id": "7949d30d5cbda8567db14c4dd6f906d5174d5e8c93c835b3cc8965648a4f2eb8",
    "metadata": {},
    "name": "PageTreeQuery",
    "operationKind": "query",
    "text": "query PageTreeQuery($spaceKey:String!,$statuses:[GraphQLPageStatus],$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!,$isReplacePagesWithPTPageEnabled:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$isReplacePagesWithPTPageEnabled){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},rootLevelPages:pages(spaceKey:$spaceKey,status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),type,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "22bf1ef7d7cdf7d20c14752762c0563b";

export default node;
